import { sanitizeText } from "../../../services/transforms/cartDataTransforms";
import { buildProductDetailPath, buildTopbarMenuStructure } from "../../../shared/utils/topbarUtils";
import { formatCLP } from "../../../utils/currency";
import { FALLBACK_IMAGE } from "../../../utils/uiConstants";

export const CATALOG_SORT_OPTIONS = [
  { label: "Sin orden", value: "" },
  { label: "Nombre A-Z", value: "nombre_asc" },
  { label: "Nombre Z-A", value: "nombre_desc" },
  { label: "Precio menor a mayor", value: "precio_asc" },
  { label: "Precio mayor a menor", value: "precio_desc" },
  // { label: "Codigo A-Z", value: "codigo_asc" },
  // { label: "Codigo Z-A", value: "codigo_desc" },
];

export const resolveProductImage = (foto, mime) => {
  const value = String(foto || "").trim();
  if (!value) return FALLBACK_IMAGE;
  if (value.startsWith("data:image")) return value;
  const type = String(mime || "").trim() || "image/jpeg";
  return `data:${type};base64,${value}`;
};

const mapCatalogProduct = (item) => ({
  codigo: sanitizeText(item?.codigo),
  descripcion: sanitizeText(item?.descripcion),
  precio: Number(item?.precio || 0),
  unidadMedida: sanitizeText(item?.unidadMedida),
  descuento: Number(item?.descuento || 0),
  stock: Number(item?.stock || 0),
  tipo: "GENÉRICO",
  // fotos[] alimenta el carrusel con fotos reales del producto.
  // image (item.foto + item.mime) es la portada real o el fallback de familia;
  // sólo se usa como src cuando fotos[] es vacio (producto sin fotos propias).
  // Caso 2 (fotos[] sin portada:true): image sera el fallback familia, pero el
  // carrusel arranca en fotos[0] (real del producto), por lo que image nunca se muestra.
  image: resolveProductImage(item?.foto, item?.mime),
  fotos: Array.isArray(item?.fotos)
    ? item.fotos.filter(Boolean).map((f) => ({
        id: f.id,
        portada: Boolean(f.portada),
        image: resolveProductImage(f.foto, f.mime),
      }))
    : [],
});

export const mapCatalogResponseProducts = (response) => {
  const rawProducts = Array.isArray(response?.productos)
    ? response.productos
    : Array.isArray(response?.data)
      ? response.data
      : [];

  return rawProducts.map(mapCatalogProduct);
};

const formatCatalogPrice = (price) => {
  if (!price) return "Precio a consultar";
  return formatCLP(price);
};

export const hasCatalogDiscount = (price, discount) =>
  Number(price) > 0 && Number(discount) > 0 && Number(discount) < 100;

export const getCatalogDiscountedPriceValue = (price, discount) =>
  hasCatalogDiscount(price, discount)
    ? Number(price) * (1 - Number(discount) / 100)
    : Number(price || 0);

export const getCatalogDiscountedPrice = (price, discount) =>
  formatCatalogPrice(getCatalogDiscountedPriceValue(price, discount));

export const getCatalogRegularPrice = (price, discount) =>
  hasCatalogDiscount(price, discount) ? formatCatalogPrice(price) : "";

export const buildCatalogMenuStructure = (families) =>
  buildTopbarMenuStructure(
    families?.catalogMenu || [],
    families?.navItems || []
  );

export const buildCatalogProductDetailPath = ({ product }) =>
  buildProductDetailPath(product?.descripcion || product?.codigo || "producto");

export const buildCatalogProductDetailState = ({ product, collection = "", subcollection = "", familyId = 0 }) => ({
  productCode: String(product?.codigo || "").trim(),
  productName: product?.descripcion || "",
  productPrice: Number(product?.precio || 0),
  collection,
  subcollection,
  familyId: Number(familyId || 0),
});

const formatHomePrice = (price) => {
  if (!price) return null;
  return formatCLP(price);
};

export const getTopProductDiscountedPrice = (price, discount) =>
  formatHomePrice(getCatalogDiscountedPriceValue(price, discount));
